function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M21.053 2.14h-8.746v15.715h8.746V2.14z",
  fill: "#FF5F00"
});

var _ref3 = React.createElement("path", {
  d: "M12.862 9.998c0-3.054 1.416-5.97 3.804-7.858C12.335-1.275 6.032-.525 2.616 3.834-.77 8.165-.02 14.44 4.339 17.855a9.97 9.97 0 0 0 12.356 0 10 10 0 0 1-3.832-7.857z",
  fill: "#EB001B"
});

var _ref4 = React.createElement("path", {
  d: "M32.853 9.998a9.99 9.99 0 0 1-9.995 9.995 9.893 9.893 0 0 1-6.164-2.138c4.331-3.415 5.08-9.69 1.666-14.049-.5-.61-1.055-1.194-1.666-1.666 4.331-3.415 10.634-2.665 14.021 1.694a9.893 9.893 0 0 1 2.138 6.164z",
  fill: "#F79E1B"
});

var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.fefd1a9d.svg";
export { ForwardRef as ReactComponent };